import { useAppStore } from 'App/store';
import { Link, useLocation } from 'react-router-dom';
import QBenchCurrency from 'shared/components/QBenchCurrency';
import permissions from 'shared/constants/permissions';
import { useBillingMetrics } from 'shared/hooks/api/misc';
import useAccessControl from 'shared/hooks/misc/useAccessControl';
import useResponsive from 'shared/hooks/misc/useResponsive';
import { noop } from 'shared/utils/misc';
import styled from 'styled-components';
import { CREATE_ORDER_PATH } from '../MainMenu';

const { read } = permissions;

const Wrapper = styled(Link)`
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 2px;
  border-color: ${props => props.theme.color.palette.text.headerText}; 
  &, &:hover {
    ${props => props.$isMobile
      ? `color: ${props.theme.color.palette.grey[600]}`
      : `color: ${props.theme.color.palette.text.headerText}`
    }
  }
`;

export default function OutstandingBalance({ toggleModal = noop }) {
  const { pathname } = useLocation();
  const { isMobile } = useResponsive();
  const { appState: { billingEnabled }, appStateDispatch } = useAppStore();
  const { data: { unpaid_balance } } = useBillingMetrics();
  const hasPermission  = useAccessControl({ privilege: [read.invoice] });

  const toPath = {
    pathname: '/portal/invoices',
    search: '?statuses=UNPAID'
  };

  function handlePreClick(e) {
    if (pathname.includes(CREATE_ORDER_PATH)) {
      e.preventDefault();
      appStateDispatch({
        type: 'RESET_CREATE_ORDER',
        payload: `${toPath.pathname}${toPath.search}`,
      });
    } else {
      appStateDispatch({ type: 'RESET_CREATE_ORDER', payload: false });
    }
  }

  if (!billingEnabled) return null;
  if (!hasPermission) return null;

  if (isMobile) return (
    <Wrapper $isMobile={isMobile} className="d-block lh-1 my-3 mb-4 text-center text-decoration-none" to={toPath} onClick={toggleModal}> 
      <span>Balance: <QBenchCurrency quantity={unpaid_balance ?? 0} /></span>
    </Wrapper>
  );


  return (
    <Wrapper $isMobile={isMobile} className="d-none px-4 lh-1 border-start d-lg-flex align-items-center text-decoration-none" to={toPath} onClick={handlePreClick}>
      <span className="d-none d-xl-inline">Balance:&nbsp;</span>
      <span><QBenchCurrency quantity={unpaid_balance ?? 0} /></span>
    </Wrapper>
  );
}

